import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "redux/axiosInterceptor";

const API_URL = process.env.REACT_APP_BASE_URL;


export const fetchAsyncCreatePaymentOtp = createAsyncThunk(
    "/fetchAsyncCreatePaymentOtp",
    async (data) => {
      try {
        const response = await axiosInstance.post(`${API_URL}/payments/create-otp`, data?.data);
        return response.data;
      } catch (error) {
        throw new Error(error.response.data.message);
      }
    }
);


export const fetchAsyncTransactionOtp = createAsyncThunk(
  "/fetchAsyncTransactionOtp",
  async (data) => {
    try {
      const response = await axiosInstance.post(`${API_URL}/payments/transaction-otp`, data?.data);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const fetchAsyncTransactionInquiry = createAsyncThunk(
  "/fetchAsyncTransactionInquiry",
  async (data) => {
    try {
      const response = await axiosInstance.post(`${API_URL}/payments/transaction-inquiry`, data);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const fetchAsyncAccountStatement = createAsyncThunk(
  "/fetchAsyncAccountStatement",
  async (data) => {
    try {
      const response = await axiosInstance.post(`${API_URL}/payments/account-statement`, data);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);
export const fetchAsyncGetPaymentDetail = createAsyncThunk(
  "/fetchAsyncGetPaymentDetail",
  async (data) => {
    try {
      const response = await axiosInstance.post(`${API_URL}/payments/payment-detail`,data);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const fetchAsyncBankBalance = createAsyncThunk(
  "/fetchAsyncBankBalance",
  async (data) => {
    try {
      const response = await axiosInstance.post(`/payments/balance-inquiry`, data);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const fetchAsyncRegisterStatus = createAsyncThunk(
  "/fetchAsyncRegisterStatus",
  async (data) => {
    try {
      const response = await axiosInstance.post(`/payments/register-status`, data);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const fetchAsyncUsePaymentDetails = createAsyncThunk(
  "/fetchAsyncUsePaymentDetails",
  async (data) => {
    try {
      const response = await axiosInstance.post(`/payments/use-payments`, data);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const fetchAsyncAccountStatementValidate = createAsyncThunk(
  "/fetchAsyncAccountStatementValidate",
  async (data) => {
    try {
      const response = await axiosInstance.post(`${API_URL}/payments/statement-validate`, data);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);